<template>
    <v-container class="my-5">
        <!--   Diálogo para Mostrar un mensaje al Eliminar Estudiante     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="500px"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_classromm')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>

                    <v-btn
                            color="primary"
                            @click="deleteStudent()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('classrooms') }}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="400px">
                <template v-slot:activator="{ on }">
                    <v-btn
                            color="primary"
                            dark
                            v-on="on"
                            @click="update = false,
                                cleanFields()"> + {{ $t('add_classroom') }}
                    </v-btn>
                </template>
                <v-form
                        @submit.prevent="update
                        ? updateClassroom(id_update)
                        : createClassroom()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('classrooms') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-autocomplete
                                v-model="grade"
                                outlined
                                placeholder="Seleccione un Grado Académico"
                                prepend-icon="mdi-school"
                                name="grade"
                                item-text="name"
                                item-value="group"
                                :label="$t('grade')"
                                :filter="customFilter"
                                :error-messages="errores.grade"
                                :items="grades"
                                no-data-text="Ningún Resultado"
                                clearable
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            @click="data.select"
                                    >
                                        {{ data.item.name }}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            <v-text-field
                                    autofocus
                                    v-model="name"
                                    outlined
                                    placeholder="Ejemplo: Salon A"
                                    prepend-icon="mdi-school-outline"
                                    name="name"
                                    :label="$t('nombre')"
                                    :error-messages="errores.name"
                            >
                            </v-text-field>
                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    transition="scale-transition"
                            >
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="clear(),
                                            dialog = false"
                            >{{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    :loading="loading"
                                    v-if="update"
                                    color="primary"
                                    type="submit"
                            >{{$t('modificar')}}
                            </v-btn>
                            <v-btn
                                    :loading="loading"
                                    v-else
                                    color="primary"
                                    type="submit"
                            >{{$t('agregar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{$t('classrooms')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-account-search"
                            :label="$t('Buscar')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loading_data_students"
                        :items="classrooms"
                        :search="search"
                        class="elevation-1"
                >
                    <template v-slot:items="props">
                        <td>{{ props.item.id }}</td>
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.grade_name }}</td>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-icon
                                medium
                                color="grey"
                                class="mr-2"
                                @click="fillFields(item), update = true, dialog = true, id_update = item.id"
                        >
                            mdi-pencil
                        </v-icon>
                        <v-icon
                                medium
                                color="red"
                                @click="deleteDialog = true, idClassroomDelete = item.id"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                    <template v-slot:no-results>
                        <v-alert type="warning">
                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                        </v-alert>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { mapState } from 'vuex'
import Vue from 'vue'
import { required } from 'vee-validate/dist/rules'

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

extend('required', {
  ...required,
  message: 'This field is required'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'classrooms',
  created () {
    this.getClassrooms()
  },
  data: () => ({
    show: false,
    alerta: false,
    dialog: false,
    update: false,
    id_update: 0,
    name: '',
    grade: '',
    errores: [],
    headers: [],
    classrooms: [],
    loading_data_students: false,
    confirmation: '',
    search: '',
    // Delete Classrrom
    deleteDialog: false,
    idClassroomDelete: 0,
    idTutor1: null,
    idTutor2: null,
    loading: false,
    grades: [
      { header: 'Kinder'},
      { name: '1° de Kinder', group: 'kinder1'},
      { name: '2° de Kinder', group: 'kinder2'},
      { name: '3° de Kinder', group: 'kinder3'},
      { divider: true },
      { header: 'Primaria' },
      { name: '1° de Primaria', group: 'primaria1'},
      { name: '2° de Primaria', group: 'primaria2'},
      { name: '3° de Primaria', group: 'primaria3'},
      { name: '4° de Primaria', group: 'primaria4'},
      { name: '5° de Primaria', group: 'primaria5'},
      { name: '6° de Primaria', group: 'primaria6'},
      { divider: true },
      { header: 'Secundaria' },
      { name: '1° de Secundaria', group: 'secundaria1'},
      { name: '2° de Secundaria', group: 'secundaria2'},
      { name: '3° de Secundaria', group: 'secundaria3'},
      { divider: true },
      { header: 'Preparatoria' },
      { name: '1° de Preparatoria', group: 'preparatoria1'},
      { name: '2° de Preparatoria', group: 'preparatoria2'},
      { name: '3° de Preparatoria', group: 'preparatoria3'}
    ],
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('nombre'),
        align: 'left',
        sortable: true,
        value: 'name'
      },
      {
        text: this.$t('grade'),
        align: 'left',
        sortable: true,
        value: 'grade_name'
      }
    ]
  },
  computed: {
    ...mapState(['language'])
  },
  methods: {
    getClassrooms () {
      this.loading_data_students = true
      HTTP.get('classroom/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.classrooms = response.data
        this.loading_data_students = false
      })
      .catch(error => {
        console.log(error)
        this.loading_data_students = false
      })
    },
    createClassroom () {
      this.loading = true
      this.errores = []
      if (this.grade === undefined || this.grade === '') {
        this.grade = null
      }
      HTTP.post('classroom/', {
        name: this.name,
        grade: this.grade
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        this.loading = false
        console.log(ok)
        this.getClassrooms()
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('msg_classroom_add'))
        this.dialog = false
        setTimeout(this.clear, 3000)
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          if (error.response.data) {
            this.errores = error.response.data
          }
        }
      })
    },
    updateClassroom (id) {
      // console.log('ID Student = ', id)
      this.loading = true
      this.errores = []
      if (this.grade === undefined || this.grade === '') {
        this.grade = null
      }
      HTTP.patch('classroom/' + id, {
        name: this.name,
        grade: this.grade
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        this.loading = false
        console.log(ok)
        this.getClassrooms()
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('msg_classroom_update'))
        this.dialog = false
        setTimeout(this.clear, 3000)
      })
      .catch(error => {
        this.loading = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          if (error.response.data) {
            this.errores = error.response.data
          }
        }
      })
    },
    deleteStudent () {
      HTTP.delete('classroom/' + this.idClassroomDelete, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        // console.log('Manager con ID = ', this.idClassroomDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('msg_classroom_delete'))
        this.getClassrooms()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    clear () {
      this.alerta = false
      this.errores = []
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    fillFields (item) {
      this.name = item.name
      this.grade = item.grade
      this.idTutor1 = item.idTutor1
      this.idTutor2 = item.idTutor2
    },
    customFilter (item, queryText) {
      const textOne = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    cleanFields () {
      this.name = ''
      this.grade = ''
      this.idTutor1 = null
      this.idTutor2 = null
    }
  }
}
</script>

<style scoped>

</style>
